var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tabActive==0)?[_c('transactionRecords',{attrs:{"tabActive":_vm.tabActive},on:{"switchTab":_vm.switchTab}})]:[_c('journal',{attrs:{"tabActive":_vm.tabActive},on:{"switchTab":_vm.switchTab}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }